<template lang="pug">
ul.faq
  li.faq__item(
    v-for="item in block.items"
    :key="item.id"
    @click="toggleItem(item.id)")
    div.faq__container
      span.faq__question(v-html="item.question")
      span.faq__symbol +
    span.faq__response(:id="item.id" v-html="item.response")
</template>

<script>
export default {
  name: 'FaqComponent',
  props: {
    block: {
      type: Object,
      default: () => {},
    }
  },
  data: () => ({
    isClosed: true,
  }),
  methods: {
    toggleItem(id) {
      const activeEl = document.querySelector(`span#${id}`)
      activeEl.classList.toggle('faq__response--visible')
      const elCollection = document.querySelectorAll('.faq__response')
      elCollection.forEach(el => {
        if (el.id !== id && el.classList.contains('faq__response--visible')) {
          el.classList.remove('faq__response--visible')
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.faq {
  &__item {
    border: 1px solid $primary;
    padding: 0.5rem 11px;
    margin-bottom: 0.88rem;
    cursor: pointer;
  }

  &__container {
    display: flex;
    justify-content: space-between;
  }

  &__question {
    margin-right: 2rem;
  }

  &__symbol {
    color: $primary;
    font-weight: bold;
  }

  &__response {
    display: block;
    color: $gray;
    line-height: 1.4;
    padding: 0;
    height: 0;
    opacity: 0;

    &--visible {
      height: auto;
      opacity: 1;
      padding: 1rem 0;
    }
  }
}

</style>
